import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getDocuments, getProfilePicture, fetchUserById } from './../actions/user-api';
import * as Loadings from '../constants/loadings/user';
import logo from './../assets/images/brand/assista.svg';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import * as R from 'ramda';
import JwtDecode from 'jwt-decode';

// Backoffice
// ==========================================
// Backoffice: Common
import { Navbar } from './_common/navbar';

// Backoffice: Views
// import {Dashboard} from './dashboard';
import { Impression } from './impression';
import { Dossiers } from './dossiers';
import { Selfcare } from "./selfcare";
import { Clients } from './clients';
import { Partners } from './partners';
import { Paiement } from './paiement';
import { Settings } from './settings';
import { Configuration } from './configuration';
import { FileTypes } from '../constants/utils/fileTypes';
import { LoadingState } from '../_common/loadingState';


export const Backoffice = () => {
	const router = useSelector(state => state.router);
	const dispatch = useDispatch();
	const user = useSelector(state => state.user);
	const impressionReducer = useSelector(state => state.impressionReducer);
	const dossiersReducer = useSelector(state => state.dossiersReducer);
	const selfcareReducer = useSelector((state) => state.selfcareReducer);
	const clientsReducer = useSelector(state => state.clientsReducer);
	const [roles, setRoles] = useState([]);

	useEffect(() => {
		var accessToken = localStorage.getItem("access_token");
		if (!R.isNil(accessToken)) {
			axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
			var decoded = JwtDecode(accessToken);
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			}
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"])) {
				setRoles(decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);



	useEffect(() => {
		if (!R.isNil(user.user)) {
			dispatch(getDocuments(user.user));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.user]);

	useEffect(() => {
		const profilePicture = user.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if (!R.isNil(profilePicture))
			dispatch(getProfilePicture(user.user.id, profilePicture.fileName));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.documents]);



	// if (R.isNil(user.user) && user.isLoading.includes(Loadings.FETCH_USER)) {
	// 	return (<div className='flex-column h-100 justify-content-center align-items-center'>
	// 		<div style={{ width: "100px", height: "100px" }} >
	// 			<img src={logo} />
	// 		</div>
	// 	</div>);
	// }

	if (R.isNil(user.user) || (!roles.includes("ADMIN") && !roles.includes("DISTRIBUTER"))) {
		return '';
	}


	return (
		<React.Fragment>
			<ToastContainer />
			<div className="layout layout-row bg-dark ga-3 ga-md-auto">
				<h1 className="sr-only visually-hidden">Assist@</h1>
				<Navbar location={router.location} roles={roles} />
				<main role="main" className="view flex-grow-1 bg-gradient-light">
					<h1 className="sr-only visually-hidden">Assist@: Backoffice</h1>
					<Switch>
						<Route path="/backoffice/impression">
							<Impression impressionState={impressionReducer} />
						</Route>
						<Route path="/backoffice/dossiers">
							<Dossiers dossierState={dossiersReducer} />
						</Route>
						<Route path="/backoffice/selfcare">
							<Selfcare selfcareReducer={selfcareReducer} isPartner={true} />
						</Route>
						<Route path="/backoffice/clients" component={Clients}>
							<Clients clientsState={clientsReducer} />
						</Route>
						<Route path="/backoffice/partners">
							<Partners user={user.user} />
						</Route>
						<Route path="/backoffice/paiement" component={Paiement} />
						<Route path="/backoffice/settings">
							<Settings roles={roles} />
						</Route>
						<Route path="/backoffice/configuration" component={Configuration} />

						<Route
							render={() => {
								if (roles.includes("ADMIN")) {
									return <Redirect exact to="/backoffice/dossiers" />;
								} else {
									return <Redirect exact to="/backoffice/impression" />;
								}
							}}
						/>
					</Switch>
				</main>
			</div>
		</React.Fragment>
	);
};